import { render, staticRenderFns } from "./EmployerInviteMembers.vue?vue&type=template&id=506756a4&scoped=true&"
import script from "./EmployerInviteMembers.vue?vue&type=script&lang=js&"
export * from "./EmployerInviteMembers.vue?vue&type=script&lang=js&"
import style0 from "./EmployerInviteMembers.vue?vue&type=style&index=0&id=506756a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506756a4",
  null
  
)

export default component.exports